import { Component, OnInit, Injector, NgZone } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslatorService } from '../../../core/translator/translator.service';

@Component({
    selector: 'app-lock',
    templateUrl: './lock.component.html',
    styleUrls: ['./lock.component.scss']
})
export class LockComponent implements OnInit {

    valForm: FormGroup;
    router: Router;
    userDisplayName: string;

    constructor(
        public settings: SettingsService,
        public fb: FormBuilder,
        public injector: Injector,
        public translatorService: TranslateService,
        public ngZone: NgZone,
        public translator: TranslatorService
    ) {
        this.valForm = this.fb.group({
            'password': [null, Validators.required]
        });
    }

    submitForm($ev, value: any) {
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        if (this.valForm.valid) {

            this.login(this.valForm.controls['password'].value)

        }
    }

    ngOnInit() {
        this.router = this.injector.get(Router);

        //Ha nincs benne a sessionben az e-mail címe akkor nem a lock gombal jött az oldalra
        if( sessionStorage.getItem('userEmail') == null){
            //Ha bevan jelentkezve és link átírással jött az oldalra akkor megy a home oldalra
            if(Accounts.loggingIn()){
                this.router.navigate(['home']);
            }
            //Ha nincs bejelentkezve akkor és link átírással jött az oldalra akkor megy a login oldalra mert úgyse tudna innen bemenni
            else{
                this.router.navigate(['/login']);
            }
        }
        this.userDisplayName = sessionStorage.getItem('userDisplayName')
    }

    login(password: string){
        let email: string = sessionStorage.getItem('userEmail');

        Meteor.loginWithPassword(email, password, (err) => {
            this.ngZone.run(
                () => {
                    if (err) {
                        this.valForm.controls['password'].setErrors({ "incorrectPasswordError": err.toString });
                    } else {
                        sessionStorage.removeItem('userEmail');
                        sessionStorage.removeItem('userDisplayName');
                        this.router.navigate(['home']);
                    }
                }
            );
        });


    }

}
